// File: src/components/solution/SolutionInfographic.js

import React from 'react';
import styles from './SolutionInfographic.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

function SolutionInfographic({ landscape = false }) {
  return (
    <section className={styles.section}>
      <div className="site-container">

        <ScrollAnimation className={styles.header}>
          <p className={styles.eyebrow}>The GreenScience Cycle</p>
          <h2 className={styles.heading}>
            Transforming Urban Organic Waste
            <br />
            into Premium Bio-Fertilizer
          </h2>
          <p className={styles.subheading}>
            A closed-loop, seven-step process that eliminates landfill waste,
            produces zero odour, and generates a premium soil product — all
            within a minimal urban footprint.
          </p>
        </ScrollAnimation>

        <ScrollAnimation
          className={cn(
            styles.imageWrap,
            landscape && styles.imageWrapLandscape
          )}
          delay={150}
        >
          <img
            src="/images/cleaned_infographic_v3.png"
            alt="The GreenScience Cycle: seven steps transforming organic waste into premium bio-fertilizer, from receiving and preparation through vermistabilization to final product processing"
            className={styles.image}
          />
        </ScrollAnimation>

      </div>
    </section>
  );
}

export default SolutionInfographic;